<template>
    <div class="cor_cert">
        <el-card class="cor_cert_card">
            <div class="cor_cert_box">
                <h2>请先进行企业认证</h2>

                <ul class="info_box">

                    <li class="info_list">
                        <p class="list_left">企业名称</p>
                        <el-input v-model="cor_name" class="input" placeholder="请输入企业名称"></el-input>
                    </li>
                    <li class="info_list logo_box">
                        <p class="list_left">品牌LOGO</p>
                        
                        <div class="crop_box">
                            <img :src="logo_local_url" v-if="logo_local_url" alt="logo" class="logo_pic">
                            <div class="logo_pic_none" v-else="logo_local_url"></div>
                            <div class="crop-demo-btn" @change="setImage">选择图片
                                <input class="crop-input" type="file" name="image" accept="image/*" @change="setImage"/>
                            </div>
                        </div>
                    </li>

                    <li class="info_list business_license">
                        <p class="list_left">请上传营业执照</p>

                        <el-upload
                            :action="upload_url"
                            :auto-upload=false
                            list-type="picture-card"
                            :on-change='uploadChange'
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :limit=1
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>

                        <el-dialog :visible.sync="dialogPicVisible">
                            <img width="100%" :src="license_local_url" alt="">
                        </el-dialog>

                        <span class="tips">营业执照上的名称必须与开通的企业名称保持一致</span>
                    </li>
                    <li class="info_list">
                        <p class="list_left">公司简称/产品名</p>
                        <el-input v-model="cor_brand" class="input" placeholder="请输入公司简称/产品名"></el-input>
                    </li>
                    <li class="info_list">
                        <p class="list_left">公司行业</p>
                        <el-select v-model="category_name" placeholder="请选择" @change="changeCategory">
                            <el-option
                            v-for="item in category_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </li>
                    <li class="info_list">
                        <p class="list_left">所在地区</p>
                        <el-select v-model="area_info.province_name" value-key="id" placeholder="请选择" @change="changeProvince">
                            <el-option
                            v-for="(item , index ) in area_list"
                            :key="item.id"
                            :label="item.name"
                            :value="index"
                            >
                            </el-option>
                        </el-select>
                        <span>&nbsp;&nbsp;省&nbsp;&nbsp;</span>
                        <el-select v-model="area_info.city_name" value-key="id" placeholder="请选择" @change="changeCity">
                            <el-option
                            v-for="item in city_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                        <span>&nbsp;&nbsp;市</span>
                    </li>
                    <li class="info_list">
                        <p class="list_left">公司介绍（选填）</p>
                        <el-input
                            class="input"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入内容"
                            v-model="cor_introduce">
                        </el-input>
                    </li>
                    <li class="info_list">
                        <p class="list_left">公司官网（选填）</p>
                        <el-input v-model="website_addres" class="input" placeholder="请输入内容"></el-input>
                    </li>
                </ul>

                <el-button type="primary" @click="submitInfo">提交审核</el-button>
            </div>
        </el-card>

        <el-dialog title="裁剪图片" :visible.sync="dialogVisible" width="30%">
                <vue-cropper ref='cropper' :src="imgSrc" :ready="cropImage" :zoom="cropImage" :cropmove="cropImage" style="width:100%;height:300px;"></vue-cropper>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelCrop">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import { Loading } from 'element-ui';

export default {
    name: "CorCert",
    components: { VueCropper},
    data() {
        return {
            corporate_info: "",         //公司信息

            dialogVisible: false,       //上传logo弹窗显示
            dialogPicVisible: false,    //上传营业执照弹窗显示

            logo_local_url: "",           //logo本地图片地址
            license_local_url: "",        //营业执照本地地址
            category_list: [],      //行业列表
            area_list: [],          //地区信息
            city_list: [],          //市级地区信息
            imgSrc: '',             //需要裁剪的图片地址
            upload_url: "http://t.qiqueqiao.com//api/v1/wechat/picture/upload",         //图片上传地址

            cor_name: "",           //企业名称
            logo_url: "",           //logo图片上传后地址
            license_url: "",        //营业执照图片上传后地址
            cor_brand: "",          //企业简称
            category_name: "",      //公司行业名称
            category_id: "",        //公司行业id
            area_info: {            //选择的地区信息
                province_id: "",
                province_name: "",
                city_id: "",
                city_name: "",
            },
            cor_introduce: "",      //公司介绍
            website_addres: "",                //公司官网地址
        }
    },
    methods: {
        // 获取公司信息
        getCorporateInfo(){
            let that = this;

            that.$request.post({url: "/corporate/info"}).then(res => {
                that.corporate_info = res.data;

                 [that.cor_name,that.logo_local_url,that.logo_url,that.license_local_url,that.license_url,that.cor_brand,that.cor_introduce,that.website_addres] = [
                     res.data.name,
                     res.data.logo,
                     res.data.logo,
                     res.data.license,
                     res.data.license,
                     res.data.brand,
                     res.data.introduce,
                     res.data.website_addres
                 ]

                // console.log(that.license_url);
            })
        },
        // 获取行业列表
        getCategoryList(){
            let that = this;

            that.$request.post({
                need_login: false,
                url: "/api/v1/resource/getScreen",
                params: {
                    category: 2
                }
            }).then((res) => {
                that.category_list = res.data;
            })
        },
        // 获取地区信息
        getAreaInfo(){
            let that = this;
            
            that.$request.post({
                need_login: false,
                url: "/api/v2/getAppArea",
            }).then((res) => {
                res.data.shift();
                that.area_list = res.data;
            })
        },
        // 选择行业
        changeCategory(id){
            this.category_id = id;
        },
        // 选择省
        changeProvince(index){
            let that = this;

            that.area_info.city_id = "";
            that.area_info.city_name = "";
            that.city_list = that.area_list[index].zlist;
        },
        // 选择市级
        changeCity(id){
            this.area_info.city_id = id;
        },
        //选择要裁剪的图片 
        setImage(e){
            const file = e.target.files[0];
            if (!file.type.includes('image/')) {
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
                this.dialogVisible = true;
                this.imgSrc = event.target.result;
                this.$refs.cropper && this.$refs.cropper.replace(event.target.result);
            };
            reader.readAsDataURL(file);
        },
        // 确定裁剪图片
        cropImage () {
            this.logo_local_url = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },
        // 取消裁剪
        cancelCrop(){
            this.dialogVisible = false;
            this.logo_url = this.defaultSrc;
        },

        // 选择营业执照图片时
        uploadChange(file,fileList){
            // console.log(file);
            let that = this;

            let reader = new FileReader();
            reader.onload = () => {
                let _base64 = reader.result
                let BASE64 = _base64.split(",")

                that.license_local_url = _base64;
            }
            reader.readAsDataURL(file.raw);
        },

        // 上传图片
        uploadPic(pic,type){
            let that = this;
            return new Promise((resolve,reject) => {
                that.$request.post({url:'/api/v1/upload',params: {
                    head_pic: pic,
                    type: type,
                }}).then(res => {
                    resolve(res);
                })
            })
        },

        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.businessImageUrl = file.url;
            this.dialogPicVisible = true;
        },

        // 点击提交审核
        submitInfo(){
            let that = this;

            if(that.cor_name == ""){
                that.$message({
                    message: "请完善企业名称",
                    type: "warning"
                })

                return;
            } else if(that.logo_local_url == "") {
                that.$message({
                    message: "请上传品牌LOGO",
                    type: "warning"
                })

                return;
            } else if(that.license_local_url == "") {
                that.$message({
                    message: "请上传营业执照",
                    type: "warning"
                })

                return;
            } else if(that.cor_brand == "") {
                that.$message({
                    message: "请完善产品名",
                    type: "warning"
                })

                return;
            } else if(that.category_id == "") {
                that.$message({
                    message: "请完善行业信息",
                    type: "warning"
                })

                return;
            } else if(that.area_info.city_id == "") {
                that.$message({
                    message: "请完善所在地区信息",
                    type: "warning"
                })

                return;
            }
            

            that.$loading();

            // 若未上传logo
            if(that.logo_url == ""){
                let logo = that.logo_local_url.split(",")[1];

                that.uploadPic(logo,"logo").then(res => {
                    that.logo_url = res.data.path;

                    // 若未上传营业执照
                    if(that.license_url == ""){
                        let license = that.license_local_url.split(",")[1];
                        that.uploadPic(license,"license").then(res => {
                            that.license_url = res.data.path;

                            // 图片上传完成后，提交所有审核信息
                            that.requestSubmitInfo();
                        })
                    } else {
                        that.requestSubmitInfo();
                    }
                })
            } else {
                console.log(that.license_url);
                if(that.license_url == ""){
                    let license = that.license_local_url.split(",")[1];

                    that.uploadPic(license,"license").then(res => {
                        that.license_url = res.data.path;

                        // 图片上传完成后，提交所有审核信息
                        that.requestSubmitInfo();
                    })
                } else {
                    that.requestSubmitInfo();
                }
            }
        },
        // 调用审核接口
        requestSubmitInfo(){
            let that = this;

            that.$request.post({url: "/corporate/submitInfo",
                params: {
                    name: that.cor_name,
                    logo: that.logo_url,
                    license: that.license_url,
                    brand: that.cor_brand,
                    company_industry: that.category_id,
                    city: that.area_info.city_id,
                    introduce: that.cor_introduce,
                    url: that.website_addres
                }
            }).then(res => {
                that.$nextTick(() => { 
                    that.$loading().close();
                });

                that.$message({
                    message: "提交成功，等待审核",
                    type: "success",
                    onClose: function(){
                        that.$router.push({
                            name: 'NotAllow',
                            params: {
                                status: 1,
                            }
                        })
                    }
                })
            })
        }
    },
    mounted(){
        let that = this;
        
        that.getCorporateInfo();
        that.getCategoryList();
        that.getAreaInfo();
    },
    
}
</script>

<style lang="stylus" scoped>
    .cor_cert
        width 100%
        height auto
        min-height 100vh
        display flex
        flex-flow column
        align-items center
        background url('../../assets/images/login_bg.png') center center no-repeat
        background-size 100% 100%
        .cor_cert_card
            width 1200px
            min-width 800px
            margin 50px 0 50px
            box-sizing border-box
            padding 20px 180px
            .cor_cert_box
                width 100%
                display flex
                flex-flow column
                align-items center
                .input
                    width 70%
                h2
                    font-size 24px
                    margin 0 0 50px
                    color #4174D7
                .info_box
                    width 100%
                    display flex
                    flex-flow column
                    align-items flex-start
                    .info_list
                        width 100%
                        height auto
                        display flex
                        align-items center
                        margin-bottom 30px
                        .list_left
                            width 120px
                            text-align right 
                            margin-right 30px
                    .business_license
                        position relative
                        margin 0 0 70px
                        .tips
                            font-size 14px
                            color #4174D7
                            position absolute
                            bottom -30px
                            left 150px
                    .logo_box
                        .logo_pic_none
                            width: 148px;
                            height: 148px;
                            background: #fbfdff;
                            border: 1px dashed #c0ccda;
                            border-radius: 5px;
                        .logo_pic
                            width: 148px;
                            height: 148px;
                            background: #fbfdff;
                            border: 1px dashed #c0ccda;
                            border-radius: 5px;
                        .crop_box{
                            display: flex;
                            align-items: flex-end;
                        }
                        .crop-demo-btn{
                            position: relative;
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            padding: 0 20px;
                            margin-left: 30px;
                            background-color: #409eff;
                            color: #fff;
                            font-size: 14px;
                            border-radius: 4px;
                            box-sizing: border-box;
                        }
                        .crop-input{
                            position: absolute;
                            width: 100px;
                            height: 40px;
                            left: 0;
                            top: 0;
                            opacity: 0;
                            cursor: pointer;
                        }
</style>




// WEBPACK FOOTER //
// src/pages/corCert/CorCert.vue